import {
  createFileRoute,
  Link as RouterLink,
  Outlet,
} from '@tanstack/react-router'

import { Wordmark } from 'components/ui/Wordmark'

import { Card } from 'containers/Card'

// Layout for all /public/* pages: renders the branded header and the page.
const PublicLayout = () => (
  <>
    <Card>
      <RouterLink to='/' aria-label='BeadedCloud home'>
        <Wordmark size={24} />
      </RouterLink>
    </Card>
    <Outlet />
  </>
)

export const Route = createFileRoute('/public')({
  component: PublicLayout,
})
